<section class="full-height flex-column">
  <vdw-tabs-menu-card
    [icon]="isEditingTuftProduct() ? 'details-blue' : 'add-blue'"
    [action]="getActionText()"
    [title]="generalForm.controls.name.value"
    [isInUse]="isTuftProductBeingUsed() && tuftProductIsLocked"
    [invalidFormMessageError]="canShowInvalidFormMessageError()"
    [isLoading]="isLoadingTuftProduct"
    [hasPermissionToEdit]="hasEditPermission()"
    [isCreateNewPage]="!isEditingTuftProduct()"
    [saving]="saving"
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="menuItems"
    [selectedMenuItem]="selectedMenuItem"
    (selectedMenuItemChange)="onSelectedMenuItemChange($event)"
    (backEvent)="navigateBack()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveTuftProduct(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="saveTuftProduct(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="saveTuftProduct(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (deleteEvent)="deleteTuftProduct()"
    (duplicateEvent)="duplicateTuftProduct()"
    (inUseEvent)="openConflictsDialog()"
  ></vdw-tabs-menu-card>

  <ng-container *appHasPermission="texstyleEditPermission">
    @if (isTuftProductBeingUsed()) {
      <div class="unlock-in-use-wrapper">
        <app-unlock-in-use
          [entityKey]="translationKeyForTuftProducts"
          [conflictsRepository]="tuftProductsService"
          [locked]="tuftProductIsLocked"
          [id]="tuftProductToSave.id"
          [name]="tuftProductToSave.name"
          (lockedChange)="unlockTuftProduct()"
        ></app-unlock-in-use>
      </div>
    }
  </ng-container>

  <div class="card-wrapper overflow-auto">
    @if (isGeneralMenuItemSelected()) {
      <mat-card class="overflow-auto" [class.skeleton]="isLoadingTuftProduct" [@fadeIn]="isLoadingTuftProduct">
        @if (canShowAddingTuftProduct()) {
          <mat-card-content class="overflow-auto">
            <div class="article">
              <form [formGroup]="generalForm" class="flex-column" appBreadcrumbFormLinker>
                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'GENERAL.NAME' | bmsTranslate }}</mat-label>
                      <input matInput type="text" formControlName="name" />
                      <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'">
                        {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
                        <a class="url" [routerLink]="getLoadLink()">{{ 'GENERAL.ACTIONS.LOAD' | bmsTranslate }}</a>
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'required'">
                        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'GENERAL.VERSION' | bmsTranslate }}</mat-label>
                      <input disabled matInput [value]="getVersion()" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="widthInCm" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'required'">
                        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'max'">
                        {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: maxWidthInCm} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'GENERAL.DIMENSIONS.GAUGE' | bmsTranslate }}</mat-label>
                      <mat-select [compareWith]="compareWithGauge" disableOptionCentering formControlName="gauge">
                        @for (gauge of gauges; track gauge) {
                          <mat-option [attr.value]="gauge" [value]="gauge"> {{ gauge.fractionalValueAsString }} inch </mat-option>
                        }
                      </mat-select>
                      <mat-error *vdwCanShowErrorForFormControl="'gauge'; error: 'required'">
                        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.STITCH_RATE' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="stitchRateInStitchesPerCm" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.PER_CENTIMETER' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'stitchRateInStitchesPerCm'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'stitchRateInStitchesPerCm'; error: 'required'">
                        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'stitchRateInStitchesPerCm'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.PRIMARY_BACKING' | bmsTranslate }}</mat-label>
                      <vdw-object-selection
                        formControlName="primaryBacking"
                        [objectName]="'TEXTILE_DATA.TUFT_PRODUCT.PRIMARY_BACKING' | bmsTranslate | lowercase"
                        [baseRouterLink]="PRIMARY_BACKING_BASE_ROUTER_LINK"
                        (selectClicked)="selectPrimaryBacking()"
                      ></vdw-object-selection>
                      <mat-error *vdwCanShowErrorForFormControl="'primaryBacking'; error: 'required'">
                        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </mat-card-content>
        }
      </mat-card>
    } @else {
      <mat-card class="skeleton-wrapper overflow-auto" [class.skeleton]="isLoadingTuftProduct" [@fadeIn]="isLoadingTuftProduct">
        @if (canShowAddingTuftProduct()) {
          <mat-card-content class="full-height overflow-auto">
            <div class="article">
              <form [formGroup]="optionalSettingsForm" class="flex-column">
                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.PILE_HEIGHT' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="pileHeightInCm" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'pileHeightInCm'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'pileHeightInCm'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.COLOR' | bmsTranslate }}</mat-label>
                      <input matInput type="text" formControlName="color" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.BLEND' | bmsTranslate }}</mat-label>
                      <input matInput type="text" formControlName="blend" />
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.STANDARD_SPEED' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="standardSpeed" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.ROTATIONS_PER_MINUTE' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'standardSpeed'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'standardSpeed'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.STANDARD_EFFICIENCY' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="standardEfficiency" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.PERCENTAGE' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'standardEfficiency'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'standardEfficiency'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field-skeleton-wrapper flex-item">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'GENERAL.WEIGHT' | bmsTranslate }}</mat-label>
                      <input matInput type="number" vdwL10nDecimal [decimals]="true" formControlName="weightInGramsPerMeter" />
                      <span matSuffix>
                        {{ 'GENERAL.UNIT.GRAMS_PER_METER' | bmsTranslate }}
                      </span>
                      <mat-error *vdwCanShowErrorForFormControl="'weightInGramsPerMeter'; error: 'badInput'">
                        {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                      </mat-error>
                      <mat-error *vdwCanShowErrorForFormControl="'weightInGramsPerMeter'; error: 'min'">
                        {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <mat-form-field class="full-width">
                  <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.DESCRIPTION' | bmsTranslate }}</mat-label>
                  <input matInput type="text" formControlName="description" />
                </mat-form-field>

                <mat-form-field class="full-width">
                  <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.TUFTING_NOTES' | bmsTranslate }}</mat-label>
                  <input matInput type="text" formControlName="tuftingNotes" />
                </mat-form-field>

                <mat-form-field class="full-width">
                  <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.BACKING_NOTES' | bmsTranslate }}</mat-label>
                  <input matInput type="text" formControlName="backingNotes" />
                </mat-form-field>
              </form>
            </div>
          </mat-card-content>
        }
      </mat-card>
    }
  </div>
</section>
